import styled from 'styled-components';

export const StyledLogo = styled.img`
  width: ${({ size }) => size ? `${size}px` : '18px'};
  height: ${({ size, h }) => h ? `${h}px` : size ? `${size}px` : '18px'};
  margin-top: ${({ mt, my }) => mt ? mt : my ? my : '0'};
  margin-bottom: ${({ mb, my }) => mb ? mb : my ? my : '0'};
  margin-left: ${({ ml, mx }) => ml ? ml : mx ? mx : '0'};
  margin-right: ${({ mr, mx }) => mr ? mr : mx ? mx : '0'};
  cursor: ${({ showPointer }) => (showPointer ? 'pointer' : 'default')};
`
